
import { Doughnut } from 'react-chartjs-2';
import { useSelector } from "react-redux";

const DonutChart = ({ dataChart, labelsChart, colors }) => {
    const texts = useSelector(state => state.translate.texts);
    const data = {
        labels: labelsChart,
        datasets: [
            {
                data: dataChart,
                backgroundColor: colors
            },

        ],
    }

    return (
        <Doughnut data={data} options={{
            title: { display: true, text: texts.scores, fontSize: 20, },
            plugins: {
                datalabels: { display: false },
                legend: {
                    display: false,
                },
            }
        }} ></Doughnut>
    )
}
export default DonutChart

